export default {
  navigationBarTitleText: intl.get('signUpSignIn.signIn')
};
